import firebase from "./lib/firebase";
require("firebase/firestore");
var db = firebase.firestore();
const slugify = require("slugify");

export function generateId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const getUID = () => {
  // return "AUCK_35";
  //return "8r8yfxrXXCWRdvlZVPq3eR0PcWM2";
  return firebase.auth().currentUser.uid;
};

export const loadLessons = async () => {
  const uid = getUID();
  const docRef = db.collection("lessons").where("owner", "==", uid);
  const docs = await docRef.get();
  return docs.docs.map(d => d.data());
};

export const saveLesson = async data => {
  const uid = getUID();
  const compRef = await db
    .collection("companies")
    .doc(uid)
    .get();
  const comp = compRef.data();

  data.id = data.id || generateId();
  data.owner = data.owner || uid;
  data.status = data.status || "Draft";
  data.category = comp.category ? comp.category.value : "";
  data.site = comp.site || "";
  data.created = data.created || new Date().getTime();
  if (!data.slug && data.name) {
    let slugBase = slugify(data.name, {
      remove: /[*+~.()'"!:@]/g,
      lower: true
    });
    let ind = 0;
    let slug = slugBase;
    while (true) {
      ind++;
      const docRef = await db
        .collection("lessons")
        .where("slug", "==", slug)
        .get();
      if (docRef.docs.length == 0) {
        break;
      }
      slug = slugBase + "-" + ind;
    }
    data.slug = slug;
  }

  const docRef = db.collection("lessons").doc(data.id);
  await docRef.set(data);
  console.log("Data to save", data);
  return data;
};

export const loadSchedules = async () => {
  const uid = getUID();
  const docRef = db.collection("schedule").where("owner", "==", uid);
  const docs = await docRef.get();
  return docs.docs.map(d => d.data());
};

export const saveSchedule = async data => {
  const uid = getUID();
  data.id = data.id || generateId();
  data.owner = data.owner || uid;
  data.status = data.status || "Draft";
  data.created = data.created || new Date().getTime();
  const docRef = db.collection("schedule").doc(data.id);
  await docRef.set(data);
  return data;
};

export const loadLocations = async () => {
  const uid = getUID();
  const docRef = db.collection("locations").where("owner", "==", uid);
  const docs = await docRef.get();
  return docs.docs.map(d => d.data());
};

export const saveLocation = async data => {
  const uid = getUID();
  const compRef = await db
    .collection("companies")
    .doc(uid)
    .get();
  const comp = compRef.data();
  console.log("COMPANY DATA", comp);
  data.id = data.id || generateId();
  data.owner = data.owner || uid;
  data.status = data.status || "Draft";
  data.description = comp.description || "";
  data.name = comp.name || "";
  data.image = comp.image || "";
  data.category = comp.category ? comp.category.value : "";
  data.site = comp.site || "";
  data.bookType = comp.bookType || "";
  data.bookWebsite = comp.bookWebsite || "";
  data.created = data.created || new Date().getTime();
  if (!data.slug && data.name) {
    let slugBase = slugify(data.name, {
      remove: /[*+~.()'"!:@]/g,
      lower: true
    });
    let ind = 0;
    let slug = slugBase;
    while (true) {
      ind++;
      const docRef = await db
        .collection("lessons")
        .where("slug", "==", slug)
        .get();
      if (docRef.docs.length == 0) {
        break;
      }
      slug = slugBase + "-" + ind;
    }
    data.slug = slug;
  }
  const docRef = db.collection("locations").doc(data.id);
  await docRef.set(data);
  return data;
};

export const loadUserCompany = async () => {
  const uid = getUID();
  const docRef = db.collection("companies").doc(uid);

  const doc = await docRef.get();
  let settings = {};
  if (doc.exists) {
    settings = doc.data();
  }
  return { ...settings, id: uid, owner: uid };
};
export const saveUserCompany = async settings => {
  const uid = getUID();
  const docRef = db.collection("companies").doc(uid);
  const company = { ...settings, owner: uid, id: uid, site: "Auckland" };
  await docRef.set(company);
  return company;
};

export const loadUserTrials = async () => {
  const uid = getUID();
  const docRef = db
    .collection("trials")
    .where("owner", "==", uid)
    .orderBy("date", "desc");
  const docs = await docRef.get();
  const result = docs.docs
    .map(d => d.data())
    .map(d => {
      const trandformed = { ...d };
      if (d.date) {
        trandformed.date = d.date.toDate();
      }
      if (d.time) {
        trandformed.time = d.time.toDate();
      }
      return trandformed;
    });
  return result;
};

export const saveUserTrial = async trial => {
  const uid = getUID();
  const id = trial.id || generateId();
  const tr = { ...trial, owner: uid, id };
  const docRef = db.collection("trials").doc(id);
  await docRef.set(tr);
  return tr;
};

export const loadUserBlogs = async () => {
  const uid = getUID();
  const docRef = await db
    .collection("blogs")
    .where("creator", "==", uid)
    .get();
  return docRef.docs.map(d => d.data());
};

export const saveBlog = async blog => {
  const uid = getUID();
  const id = blog.id || generateId();
  const tr = { ...blog, creator: uid, id, status: blog.status || "Draft" };
  const docRef = db.collection("blogs").doc(id);
  await docRef.set(tr);
  return tr;
};
